import React from "react";

function Extron() {
    return(
        <h1>This si the extron page</h1>
    );
}

export default Extron